




































import PersonalDataForm, {
  PersonalDataFormEvent,
} from '@/components/forms/studentData/PersonalDataForm.vue';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import pipeline from '@/pipeline';
import Vue from 'vue';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    BottomButton,
    PersonalDataForm,
    PipelineMenu,
  },
  data() {
    return {
      form: {
        cpf: this.$store.getters.personalData?.cpf || '',
        race: this.$store.getters.personalData?.race || '',
        gender: this.$store.getters.personalData?.gender || '',
        birthDate: this.$store.getters.personalData?.birthDate || '',
        nationality: this.$store.getters.personalData?.nationality || '',
        placeOfBirth: this.$store.getters.personalData?.placeOfBirth || '',
        householdIncome: this.$store.getters.personalData?.householdIncome || '',
        partnerCode: this.$store.getters.partnerCode || '',
        cityBirth: this.$store.getters.personalData?.cityBirth || '',
      },
      hasErrors: false,
      cpfError: false,
      isContinueDisabled: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { partnerCode, ...personalData } = this.form;
      return Object.values(personalData).every(Boolean) && !this.hasErrors;
    },
  },
  async created() {
    await this.$store.dispatch(AnalyticsActions.ENROLLMENT_STARTED);
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.isContinueDisabled = true;
      try {
        const { partnerCode, ...personalData } = this.form;
        await this.$store.dispatch('UPDATE_PERSONAL_DATA', { personalData, partnerCode });
        pipeline.next();
      } catch (err) {
        if (err.message === 'CPF already exists') this.cpfError = true;
        else throw err;
      } finally {
        this.isContinueDisabled = false;
      }
    },
    inputHandler(event: PersonalDataFormEvent, hasErrors: boolean) {
      this.hasErrors = hasErrors;
      this.form = event;
      this.cpfError = false;
    },
  },
});
